import React, { Component } from 'react';

export default class Register extends Component {
	constructor(props) {
		super(props);
		this.state = {
			page: 0,
			emailError: false
		};
	}
	checkPage0 = () => {
		var validCodes = ["0160", "0161", "0261", "0262", "0287", "0288", "0321", "0321", "0323", "0441", "0442"]
		fetch(window.location.origin + window.location.pathname + 'checkForDuplicateNPI', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.setState({ userTypeError: false, npiError: false, firstNameError: false, lastNameError: false }, () => {
					if (!this.props.data["Participant Type"]) {
						this.setState({ userTypeError: 'Please select a user type.' })
					} else if (!this.props.data.NPI || this.props.data.NPI.length != 10 || !this.checkValidNPI(this.props.data.NPI)) {
						this.setState({ npiError: 'Please supply a valid NPI.' })
					}
					else if (this.props.data["Participant Type"] == "Dispenser" && !validCodes.includes(this.props.data.CategoryOfService)) {
						this.setState({ COSError: 'Enter the four-digit Category of Service.' })

					} else if (!this.props.data.FirstName || this.props.data.FirstName.length < 1) {
						this.setState({ firstNameError: 'Please enter your first name.' })
					} else if (!this.props.data.LastName || this.props.data.LastName.length < 1) {
						this.setState({ lastNameError: 'Please enter your last name.' })
					} else {
						fetch(window.location.origin + window.location.pathname + 'registerData', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
							if (response.status == 200) {
								this.changePage(1)
							} else {
								this.setState({ lastNameError: 'Unknown Error' })
							}

						})

					}
				})
			} else {
				this.setState({ npiError: "NPI already in use. If you've forgotten your password, please contact the system administrator." })
			}
		})

	}

	changePage = (page) => {
		this.setState({ page: page })
	}

	sendRegistrationEmail = () => {
		if (!this.props.data.Email.length > 3 || !this.props.data.Email.includes('@') || !this.props.data.Email.includes('.')) {
			this.setState({ emailError: 'Invalid Email Format Provided' })
		} else {
			this.setState({ emailError: '' })
			fetch(window.location.origin + window.location.pathname + 'sendregistrationemail', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
				if (response.status == 200) {
					this.changePage(2)
				} else {
					this.setState({ emailError: await response.text() })
				}

			})
		}
	}
	checkForDupNPI = () => {
		console.log("Yo")

	}
	checkValidNPI = (NPI) => {
		var value = ''
		var numberArray = []
		value = NPI.slice(0, -1)
		numberArray.push(24)
		numberArray.push(this.doubleAndCombine(value.slice(0, 1)))
		numberArray.push(parseInt(value.slice(1, 2)))
		numberArray.push(this.doubleAndCombine(value.slice(2, 3)))
		numberArray.push(parseInt(value.slice(3, 4)))
		numberArray.push(this.doubleAndCombine(value.slice(4, 5)))
		numberArray.push(parseInt(value.slice(5, 6)))
		numberArray.push(this.doubleAndCombine(value.slice(6, 7)))
		numberArray.push(parseInt(value.slice(7, 8)))
		numberArray.push(this.doubleAndCombine(value.slice(8, 9)))

		var result = numberArray.reduce((a, b) => a + b, 0)
		if (result.toString().slice(0, -1) == 0) {
			return true
		} else {
			var roundNumber = Math.ceil(result / 10) * 10;
			if ((roundNumber - result) == (NPI.substr(-1))) {
				return true
			} else {
				return false
			}
		}
	}
	doubleAndCombine = (numbertoProcess) => {
		var number = parseInt(numbertoProcess) * 2;
		if (number.toString().length == 2) {
			return parseInt(number.toString().slice(0, 1)) + parseInt(number.toString().slice(1, 2))
		} else {
			return number
		}
	}

	confirmRegistrationEmail = () => {
		fetch(window.location.origin + window.location.pathname + 'confirmregistrationemail', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.changePage(3)
			} else {
				this.setState({ emailError: await response.text() })
			}
		})
	}

	sendRegistrationSMS = () => {
		if (! /\d{10}/g.test(this.props.data.Phone)) {
			this.setState({ smsError: 'Please use a ten digit phone number ex: 5551237890' })
		} else {
			this.setState({ smsError: '' })
			fetch(window.location.origin + window.location.pathname + 'sendregistrationsms', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
				if (response.status == 200) {
					this.changePage(4)
				} else {
					this.setState({ smsError: await response.text() })
				}
			})
		}
	}

	confirmRegistrationSMS = () => {
		fetch(window.location.origin + window.location.pathname + 'confirmregistrationsms', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.changePage(5)
			} else {
				this.setState({ smsError: await response.text() })
			}
		})
	}


	completeRegistration = () => {
		this.props.data.Prescriber_ID = this.props.data.NPI
		fetch(window.location.origin + window.location.pathname + 'confirmregistration', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.props.completeRegistration()
			} else {
				this.setState({ passwordError: await response.text() })
			}

		})
	}

	render() {
		if (this.state.page == 0) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Create a New User Account. </h3>
					<hr />
					<p>Select Type of User</p>
					<div className="toggle">
						<div className={this.props.data["Participant Type"] == 'Prescriber' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setRegisterData('Participant Type', 'Prescriber') }}>Prescriber</div>
						<div className={this.props.data["Participant Type"] == 'Dispenser' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setRegisterData('Participant Type', 'Dispenser') }}>Dispenser</div>
					</div>
					<p>NPI</p>
					<input type="text" value={this.props.data.NPI} onChange={(e) => { this.props.setRegisterData('NPI', e.currentTarget.value) }} />
					{this.state.npiError ? <div className="error">{this.state.npiError}</div> : ''}
					{this.props.data["Participant Type"] == 'Dispenser' ? <p>Enter the four-digit Category of Service</p> : ''}
					{this.props.data["Participant Type"] == 'Dispenser' ? <input type="text" value={this.props.data.CategoryOfService} onChange={(e) => { this.props.setRegisterData('CategoryOfService', e.currentTarget.value) }} /> : ''}
					{this.state.COSError ? <div className="error">{this.state.COSError}</div> : ''}
					<p>First Name</p>
					<input type="text" value={this.props.data.FirstName} onChange={(e) => { this.props.setRegisterData('FirstName', e.currentTarget.value) }} />
					{this.state.firstNameError ? <div className="error">{this.state.firstNameError}</div> : ''}
					<p>Last Name</p>
					<input type="text" value={this.props.data.LastName} onChange={(e) => { this.props.setRegisterData('LastName', e.currentTarget.value) }} />
					{this.state.lastNameError ? <div className="error">{this.state.lastNameError}</div> : ''}
					<p style={{ fontSize: '12px', lineHeight: '1.5' }}>
						Prior Approvals submitted by unenrolled providers will be rejected by eMedNY
					</p>
					<p style={{ fontSize: '12px' }}>
						upon activation by the pharmacy or DME vendor, without notification to the submitter.
					</p>
					<div className="button" onClick={this.checkPage0}>Continue</div>
				</div>
			);
		} else if (this.state.page == 1) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Enter Email Address</h3>
					<hr />
					<p>Email Address</p>
					<input type="text" key="Email" value={this.props.data.Email} onChange={(e) => { this.props.setRegisterData('Email', e.currentTarget.value) }} />
					{this.state.emailError ? <div className="error">{this.state.emailError}</div> : ''}
					<div className="button" onClick={this.sendRegistrationEmail}>Send Confirmation Email</div>
				</div>
			)
		} else if (this.state.page == 2) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Confirm Email Address</h3>
					<hr />

					<h5 style={{ padding: '0px 15px', maxWidth: '600px', textAlign: 'justify', color: '#555', fontWeight: 300 }}>A confirmation email has been sent to {this.props.data.Email}. Please enter the confirmation code in the box below.</h5>

					<p>Email Confirmation Code</p>
					<input type="text" key="EmailConfirmation" value={this.props.data.EmailConfirmation} onChange={(e) => { this.props.setRegisterData('EmailConfirmation', e.currentTarget.value) }} />
					{this.state.emailError ? <div className="error">{this.state.emailError}</div> : ''}
					<div className="button" style={this.props.data.EmailConfirmation && this.props.data.EmailConfirmation.length == 6 ? {} : { backgroundColor: '#888' }} onClick={this.confirmRegistrationEmail}>Confirm</div>
				</div>
			)

		} else if (this.state.page == 3) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Enter Mobile Phone Number</h3>
					<hr />
					<p>Phone Number</p>
					<input type="text" value={this.props.data.Phone} onChange={(e) => { this.props.setRegisterData('Phone', e.currentTarget.value) }} />
					{this.state.smsError ? <div className="error">{this.state.smsError}</div> : ''}
					<div className="button" onClick={this.sendRegistrationSMS}>Send Confirmation Text</div>
				</div>
			)
		} else if (this.state.page == 4) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Confirm Phone Number</h3>
					<hr />

					<h5 style={{ padding: '0px 15px', maxWidth: '500px', textAlign: 'justify', color: '#555', fontWeight: 300 }}>A confirmation text message has been sent to the phone number ending in {this.props.data.Phone.substring(this.props.data.Phone.length - 4)}. Please enter the confirmation code in the box below.</h5>

					<p>Phone Number Confirmation Code</p>
					<input type="text" value={this.props.data.PhoneConfirmation} onChange={(e) => { this.props.setRegisterData('PhoneConfirmation', e.currentTarget.value) }} />
					{this.state.smsError ? <div className="error">{this.state.smsError}</div> : ''}
					<div className="button" style={this.props.data.PhoneConfirmation && this.props.data.PhoneConfirmation.length == 6 ? {} : { backgroundColor: '#888' }} onClick={this.confirmRegistrationSMS}>Confirm</div>
				</div>
			)

		} else if (this.state.page == 5) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Create a Password</h3>
					<hr />

					<p>Password</p>
					<input type="password" value={this.props.data.Password} onChange={(e) => { this.props.setRegisterData('Password', e.currentTarget.value) }} />
					{this.state.passwordError ? <div className="error">{this.state.passwordError}</div> : ''}
					<div className="button" style={this.props.data.Password && this.props.data.Password.length > 8 ? {} : { backgroundColor: '#888' }} onClick={this.completeRegistration}>Complete Registration</div>
				</div>
			)
		}


	}
}